"use client";




export default function Hero404() {
  return (
    <div className="mt-28 w-full bg-gradient-to-b from-background from-10% via-secondary/20 via-60% to-background">
      <div className="flex flex-col items-center">
        <div className="h-[60vh] flex flex-col items-center justify-center flex-grow w-full gap-8 px-4 py-20 lg:px-10">
          <h1 className="text-center text-5xl font-bold sm:text-7xl">
            Lost in the network?
          </h1>
          <p className="text-lg text-center text-muted-foreground max-w-3xl">
            The SIM2GO portal you tried to reach doesn't exist. Maybe it's been
            rerouted or encrypted. Reach out to our support team if you think
            this is a glitch.
          </p>
          <a
            href="/"
            className="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground shadow hover:bg-primary/90 p-3 px-6 py-3 text-lg font-medium transition rounded-md shadow-md"
          >
            Return to Main Terminal
          </a>
        </div>
      </div>
    </div>
  );
}
